import React from 'react';
import { FieldError } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { ShowFormError } from '@/components/forms/FormError';

interface FormFieldProps {
  label: string;
  name: string;
  children: React.ReactNode;
  error?: FieldError;
}

export const FormField: React.FC<FormFieldProps> = ({ label, name, children, error }) => {
  return (
    <div>
      <Label htmlFor={name}>{label}</Label>
      <div className="mt-1">{children}</div>
      <ShowFormError message={error?.message} />
    </div>
  );
};
